module.exports = __webpack_public_path__ + "static/img/comments_user01@2x.7a58b3ff.png";